let isPixelInitialized = false;
let isInitializing = false;

export const initFacebookPixel = (pixelId) => {
  if (typeof window === 'undefined' || isPixelInitialized || !pixelId) return;
  if (isInitializing) return;
  isInitializing = true;

  if (!window.fbq) {
    window.fbq = function () {
      window.fbq.callMethod ?
        window.fbq.callMethod.apply(window.fbq, arguments) :
        window.fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }

  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
  isPixelInitialized = true;
  isInitializing = false;
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.fbq && isPixelInitialized) {
    const { event_id, ...rest } = eventParams;
    window.fbq('track', eventName, {
      ...rest,
      eventID: event_id, // ✅ Correct way to pass event_id
    });
  }
};
